import * as React from 'react'
import { Download01Icon } from '@repo/studio-design-system-ui-icons/general/download-01'
import { useTranslation } from 'react-i18next'
import { tw } from 'utils/classnames'

export function AidaImageDropOverlay({
  over,
  kind = 'image',
}: {
  over: boolean
  kind?: 'image' | 'file'
}) {
  const { t } = useTranslation('components')
  return (
    <div
      aria-hidden
      className={tw(
        'aida-drop-overlay pointer-events-none absolute inset-2 z-30 flex items-center justify-center',
        over && 'aida-drop-overlay-over',
      )}
    >
      <div className="flex flex-col items-center gap-2 studio-typography-14">
        <Download01Icon className="size-6" />
        <span>{t(dropOverlayLabel(kind, over))}</span>
      </div>
    </div>
  )
}

function dropOverlayLabel(kind: 'image' | 'file', over: boolean) {
  if (kind === 'file') {
    return 'studio.components.aida.drop_file' as const
  }
  if (over) {
    return 'studio.components.aida.drop_release' as const
  }
  return 'studio.components.aida.drop_image' as const
}

export function AidaBubbleDropFrame({
  available,
  over,
  className,
  children,
}: {
  available: boolean
  over: boolean
  className?: string
  children: React.ReactNode
}) {
  const { t } = useTranslation('components')
  const signaled = available || over
  return (
    <div
      className={tw(
        'relative',
        className,
        signaled && 'aida-bubble-available',
        over && 'aida-bubble-over',
      )}
    >
      {children}
      {signaled ? (
        <span className="aida-bubble-badge">{t('studio.components.aida.drop_image_badge')}</span>
      ) : null}
    </div>
  )
}
